import { Card } from 'antd';

const Permissions = () => {
  return (
    <Card title="权限管理">
      权限管理页面
    </Card>
  );
};

export default Permissions; 